<div *ngIf="orderedProducts" [class.order-modal-show]="isOrderModalShow" [class.order-modal-hide]="!isOrderModalShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h3 class='text-center'>Замовлення №{{ currentOrder.id }} від {{ currentOrder.date }}</h3>
  <p>
    Сума замовлення:
    <b *ngIf="currentOrder.currency_id == 3">({{ currentOrder.summa }} UAH)</b>
    {{ (currentOrder.summa / currencies[3].rate).toFixed(2) }} EUR
  </p>

  <p>{{ (currentOrder.liters).toFixed(2) }} л.</p>
  <p>Тип доставки: {{ currentOrder.courier }}</p>
  <p *ngIf="currentOrder.courier_num">Відділення: {{ currentOrder.courier_num }}</p>
  <p *ngIf="currentOrder.city">Місто: {{ currentOrder.city }}</p>
  <p *ngIf="currentOrder.fio">Одержувач: {{ currentOrder.fio }}</p>
  <p *ngIf="currentOrder.phone">Телефон одержувача: {{ currentOrder.phone }}</p>
  <p *ngIf="currentOrder.datedelivery">Дата відправки: {{ currentOrder.datedelivery }}</p>
  <p *ngIf="currentOrder.deliveryHours">Час відправки: {{ currentOrder.deliveryHours }}</p>
  <p *ngIf="currentOrder.liters || !currentOrder.liters">Кількість літрів: {{ (currentOrder.liters).toFixed(2) }}</p>
  <p *ngIf="currentOrder.comment">Коментар: {{ currentOrder.comment }}</p>
  <br>
  <table class='order_data'>
    <thead>
    <tr>
      <th></th>
      <th>Найменування</th>
      <th>Фасовка</th>
      <th>Артикул</th>
      <th>Ціна</th>
      <th>Кіл</th>
      <th>Сума</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let op of orderedProducts">
      <td>
        <input
          *ngIf="op.allow_self_return && !op.is_returned &&
              ((op.pack_id !== 772 && op.pack_id != 774 && op.pack_id != 775 && op.pack_id!= 776 && op.pack_id != 777 && op.pack_id != 888 && op.pack_id != 999) &&
              !op.z_good_id ||
              (op.z_good_id && (currentOrder.status_id === 1 || !!allow_to_return_goods_from_zakupolog)))"
          type='checkbox'
          [(ngModel)]="op.checkedReturned"
          (change)="checkValue()"
          class="input-checkbox"
        >
        <div
          *ngIf="op.z_good_id && !allow_to_return_goods_from_zakupolog && currentOrder.status_id !== 1 && !op.is_returned"
          class="info">
          <i class="fa fa-info-circle">
            <div class="bulb-info-message">
              <div class="bulbarrow"></div>
              <div class="description">
                <span class="text">Повернення обраних позицій неможливе, <br> товар вже відвантажено!</span>
                <p class="attention">Увага!!!</p>
                <p>Замовні позиції обміну та поверненню не підлягають.</p>
                <p>Партнерський склад – це замовна позиція.</p>
                <p>Терміни доставки партнерських пропозицій можуть змінюватись,</p>
                <p>можуть бути відмови постачання.</p>
              </div>
            </div>
          </i>
        </div>
      </td>
      <td>
        {{ op.name }}
        <div class="cannot-return-message" *ngIf="op.z_good_id && !allow_to_return_goods_from_zakupolog && currentOrder.status_id !== 1 && !op.is_returned">(Товар повернути неможливо!)</div>
      </td>
      <td>{{ op.pack }}</td>
      <td>
        {{ op.firstArticle }}
        <div class="prebulb">
          <label *ngIf="op.lastArticles" (click)="articlesShow()">
            {{ op.resultLastArticleGood.length }}
          </label>
          <div class="bulb" *ngIf="op.lastArticles">
            <div class="bulbarrow"></div>
            <span>
              <div *ngFor="let article of op.lastArticles">
                {{ article }}
              </div>
            </span>
          </div>
        </div>
      </td>
      <td>{{ op.price }}</td>
      <td>{{ op.count }}</td>
      <td>{{ op.summa }}</td>
    </tr>
    </tbody>
  </table>

  <div *ngIf="!isReturnedAll" class="comment-text">
    <span>{{ errorCheckboxMessage }}</span>
  </div>

  <div *ngIf="!isReturnedAll" class='row'>
    <div class='shrink'>
      <a class='button small' [class.button-disabled]="!changeButton" (click)="prepareDataToReturn()">Повернення
        відмічених</a>
    </div>
  </div>
</div>

<div class="dark-layer"
     [class.modals-show]="isDarkBackground"
     (click)="closeModal()">
</div>

<app-modal-formation-request-return
  [orderedProducts]="orderedProducts"
  [currentOrder]="currentOrder"
  [returnStatuses]="returnStatuses"
  [deliveryDates]="deliveryDates"
></app-modal-formation-request-return>
